import { motion } from "framer-motion";
import { skillGroups, alsoUse } from "../data/skills";
import s from "./Skills.module.css";

const grid = {
  hidden: {},
  show: { transition: { staggerChildren: 0.07 } },
};

const cell = {
  hidden: { opacity: 0, y: 28 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] } },
};

export default function Skills() {
  return (
    <section id="skills" className={`section ${s.skills}`} aria-labelledby="skills-title" tabIndex={-1}>
      <div className="container">
        <h2 id="skills-title" className="section-title">
          What I work with
        </h2>

        <motion.div
          className={s.bento}
          variants={grid}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.15 }}
        >
          {skillGroups.map((group) => (
            <motion.div key={group.id} className={`${s.cell} ${s[group.id]}`} variants={cell}>
              <h3 className={s.label}>{group.label}</h3>
              <ul className={s.items}>
                {group.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </motion.div>
          ))}

          <motion.div className={`${s.cell} ${s.also}`} variants={cell}>
            <h3 className={s.label}>Also in the toolbox</h3>
            {/* The page's one marquee. The duplicate track is hidden from assistive tech. */}
            <div className={s.marquee}>
              <ul className={s.track}>
                {alsoUse.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
              <ul className={s.track} aria-hidden="true">
                {alsoUse.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
